/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ResultStates } from './ResultStates';
import {
    ResultStatesFromJSON,
    ResultStatesFromJSONTyped,
    ResultStatesToJSON,
} from './ResultStates';
import type { TopFundsViewModel } from './TopFundsViewModel';
import {
    TopFundsViewModelFromJSON,
    TopFundsViewModelFromJSONTyped,
    TopFundsViewModelToJSON,
} from './TopFundsViewModel';

/**
 * 
 * @export
 * @interface ResultOfTopFundsViewModel
 */
export interface ResultOfTopFundsViewModel {
    /**
     * 
     * @type {ResultStates}
     * @memberof ResultOfTopFundsViewModel
     */
    resultState: ResultStates;
    /**
     * 
     * @type {string}
     * @memberof ResultOfTopFundsViewModel
     */
    type?: string;
    /**
     * 
     * @type {number}
     * @memberof ResultOfTopFundsViewModel
     */
    status?: number;
    /**
     * 
     * @type {string}
     * @memberof ResultOfTopFundsViewModel
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ResultOfTopFundsViewModel
     */
    detail?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResultOfTopFundsViewModel
     */
    errors: Array<string>;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ResultOfTopFundsViewModel
     */
    validationErrors: { [key: string]: Array<string>; };
    /**
     * 
     * @type {TopFundsViewModel}
     * @memberof ResultOfTopFundsViewModel
     */
    data?: TopFundsViewModel;
    /**
     * 
     * @type {number}
     * @memberof ResultOfTopFundsViewModel
     */
    count: number;
}

/**
 * Check if a given object implements the ResultOfTopFundsViewModel interface.
 */
export function instanceOfResultOfTopFundsViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "resultState" in value;
    isInstance = isInstance && "errors" in value;
    isInstance = isInstance && "validationErrors" in value;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function ResultOfTopFundsViewModelFromJSON(json: any): ResultOfTopFundsViewModel {
    return ResultOfTopFundsViewModelFromJSONTyped(json, false);
}

export function ResultOfTopFundsViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfTopFundsViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'resultState': ResultStatesFromJSON(json['ResultState']),
        'type': !exists(json, 'Type') ? undefined : json['Type'],
        'status': !exists(json, 'Status') ? undefined : json['Status'],
        'title': !exists(json, 'Title') ? undefined : json['Title'],
        'detail': !exists(json, 'Detail') ? undefined : json['Detail'],
        'errors': json['Errors'],
        'validationErrors': json['ValidationErrors'],
        'data': !exists(json, 'Data') ? undefined : TopFundsViewModelFromJSON(json['Data']),
        'count': json['Count'],
    };
}

export function ResultOfTopFundsViewModelToJSON(value?: ResultOfTopFundsViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ResultState': ResultStatesToJSON(value.resultState),
        'Type': value.type,
        'Status': value.status,
        'Title': value.title,
        'Detail': value.detail,
        'Errors': value.errors,
        'ValidationErrors': value.validationErrors,
        'Data': TopFundsViewModelToJSON(value.data),
        'Count': value.count,
    };
}

